<template>
    <div
        id="nlto"
        :class="{ hidden: !showing }"
        v-if="exists"
        @keydown.esc="doClose"
        tabindex="0"
        role="dialog"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description">
        <div class="tobox">
            <slot></slot>

            <a href="#" class="toclose" aria-label="Close Notification" v-on:click.prevent="doClose"></a>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VueCookies from 'vue-cookies'
    Vue.use(VueCookies)

    export default {
        components: {},

        data() {
            return {
                disabledHandle: null,
                exists: true,
            }
        },

        props: {
            showing: {
                type: Boolean,
                default: false
            },
            method: {
                type: String,
                default: ''
            }
        },

        watch: {
            showing( newValue, oldValue ) {
                if( newValue ) {
                    this.lockFocus()
                }

                if( oldValue ) {
                    this.doClose()
                }
            }
        },

        mounted() {
            if( this.showing ) {
                if (window.Formie) {
                    let $form = document.querySelector('#nlto form');
                    window.Formie.initForm( $form );
                    // if( $form.form && $form.form.formTheme ) {
                    //     $form.form.formTheme.updateFormHash();
                    // }

                    // Fetch the new token for the form and replace the CSRF input with our new one
                    let $csrfInput = $form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
                    fetch('/actions/formie/forms/refresh-tokens?form=newsletter')
                        .then(result => { return result.json(); })
                        .then(result => { $csrfInput.outerHTML = result.csrf.input; })
                }

                this.lockFocus()

                $cookies.set('seento', true)
            }
        },

        methods: {
            doClose() {
                this.exists = false
                document.body.classList.remove('has-takeover')
                this.disabledHandle.disengage();
            },

            lockFocus() {
                document.body.classList.add('has-takeover')

                this.disabledHandle = ally.maintain.disabled({
                    filter: document.getElementById('nlto'),
                });

                setTimeout(() => {
                    document.querySelector('#nlto input[type="email"]').focus()
                }, 300);
            }
        }
    }
</script>

<style>
    #nlto {
        --fui-input-box-shadow-focus: 'none';
        --fui-submit-btn-box-shadow-focus: 'none';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100000;
        background: rgba(0,0,0,0.95);
        background: linear-gradient(
            0deg,
            rgba(0,0,0,0.9375) 0%,
            rgba(22,22,22,0.90625) 100%
        );
        display: flex;
        align-items: center;
        justify-content: center;

        &.hidden {
            position: absolute;
            top: 0;
            left: 0;
            right: 100vw;
            bottom: 100vh;
            z-index: -1;
            overflow: hidden;
        }

        #dialog-title {
            font-size: 4.25rem;
            font-family: var(--headline);
            margin-top: 0;
            font-weight: 500;
            line-height: 1.3em;
            padding-right: 7rem;

            @media screen and (min-width: 448px) {
                padding-right: 9.5rem;
            }
        }

        #dialog-description p {
            font-size: 2rem;

            @media only screen and (max-width:800px) {
                font-size: 2.5rem;
            }

            @media only screen and (max-width:500px) {
                font-size: 2.2rem;
            }
        }

        .fui-label {
            font-size: 14px;
            color: #fff;
            font-weight: 300 !important;
        }

        input[type=email] {
            box-sizing: border-box;
            padding: 2.5rem;
            font-size: 18px;
            color: #fff;
            border: 3px solid #fff;
            background: transparent;
            width : 100%;
            margin-bottom: 20px;

            &:focus, &:focus-within, &:hover {
                background: rgba(0,0,0,0.7);
                border-color: var(--mustard);
            }
        }

        button[type=submit] {
            padding: 1.5rem 2.5rem;
            color: #fff;
            background:transparent;
            border: 2px solid #fff;
            cursor: pointer;
            font-size: 16px;
            text-transform: uppercase;

            &:hover, &:focus, &:active {
                border-color: var(--mustard);
                background: var(--mustard);
                color:#000;
            }
        }

    }

    .tobox {
        background-color: #000;
        padding: 24px;
        max-width: 640px;
        color : #fff;
        position: relative;

        @media only screen and (min-width: 759px) {
            padding: 40px;
        }

        @media only screen and (min-width: 1279px) {
            max-width: 704px;
            padding: 56px;
        }
    }

    .toclose {
        position: absolute;
        top: 24px;
        right: 24px;
        width: 40px;
        height: 40px;
        opacity: 0.8;
        z-index: 100000;

        @media only screen and (max-width: 1279px) {
            top: 20px;
            right: 20px;
        }

        @media only screen and (max-width:800px) {
            width: 44px;
            height: 44px;
        }

        @media only screen and (max-width: 759px) {
            top: 26px;
            right: 20px;
        }

        &:focus,
        &:hover {
            opacity: 1;

            &:before, &:after {
                background-color: #1f8297;
            }

        }

        &:before, &:after {
            position: absolute;
            left: 50%;
            content: '';
            height: 40px;
            width: 4px;
            background-color: #fff;
            z-index: 1000;

            @media only screen and (max-width:800px) {
                height: 44px;
            }
        }

        /*
         * The translate values center the "X" inside the close button.
         * Can be noticed when the close button is focused.
         */
        &:before {
            transform: rotate(45deg) translate(-1.414px, 1.414px);
        }

        &:after {
            transform: rotate(-45deg) translate(-1.414px, -1.414px);
        }
    }
</style>